// @flow
import { isPersian } from '@persian-tools/persian-tools';


/**
 * Check if string is in persian.
 * @param {string} str
 * @param {boolean} isComplex in complex mode, we accept some specific characters which are common in Farsi text.
 * @return {boolean} Return true if the entered string does not include other-language characters.
 */

function checkPersian(str : string = '', isComplex : boolean = true): boolean {
	if (!str) return true;

	return isPersian(str, isComplex)
}

export default checkPersian;